import { render, staticRenderFns } from "./compare-rosters.vue?vue&type=template&id=0cbf9b68&scoped=true"
import script from "./compare-rosters.vue?vue&type=script&lang=js"
export * from "./compare-rosters.vue?vue&type=script&lang=js"
import style0 from "./compare-rosters.styl?vue&type=style&index=0&id=0cbf9b68&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf9b68",
  null
  
)

export default component.exports